import { render } from "./checkReentry.vue?vue&type=template&id=29401b4c&scoped=true&ts=true"
import script from "./checkReentry.vue?vue&type=script&lang=ts"
export * from "./checkReentry.vue?vue&type=script&lang=ts"

import "./checkReentry.vue?vue&type=style&index=0&id=29401b4c&scoped=true&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29401b4c"]])

export default __exports__